import {
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Box,
  Text,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import IsDesktop from '../../utils/IsDesktop';

const PitchDeckModal = ({
  isOpen,
  onClose,
  pitchDeckLink,
}) => {
  const isDesktop = IsDesktop();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent width={{ base: '90%', md: 'xl' }}>
        <ModalHeader>Pitch Deck</ModalHeader>
        <ModalBody p={4}>
        <Box w="100%" display="flex" alignItems="center" flexDir="column">
              {isDesktop ? (
                <Box w="80%" px={isDesktop ? 8 : 4} py={4}>
                  {pitchDeckLink ? (
                    <iframe
                      title="document viewer"
                      src={`https://docs.google.com/viewer?url=${pitchDeckLink}&embedded=true&#zoom=FitH`}
                      width="100%"
                      height="600px"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML =
                          '<Text className="text-gray-600 font-semibold p-3 text-center text-sm">Unable to load pitch deck</Text>';
                      }}
                    ></iframe>
                  ) : (
                    <Text className="text-gray-600 font-semibold p-3 text-center text-sm">
                      No pitch deck uploaded
                    </Text>
                  )}
                </Box>
              ) : (
                <Box py={4} w="100%">
                  {pitchDeckLink ? (
                    <object
                      width="100%"
                      height="600px"
                      data={`https://drive.google.com/viewerng/viewer?embedded=true&url=${pitchDeckLink}&#zoom=FitH`}
                      type="application/pdf"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        const iframe = e.target.querySelector('iframe');
                        if (iframe) {
                          iframe.style.display = 'block';
                        }
                      }}
                    >
                      <iframe
                        title="document viewer"
                        src={`https://docs.google.com/viewer?url=${pitchDeckLink}&embedded=true&#zoom=FitH`}
                        width="100%"
                        height="600px"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.parentElement.innerHTML =
                            '<Text className="text-gray-600 font-semibold p-3 text-center text-sm">Unable to load pitch deck</Text>';
                        }}
                      ></iframe>
                    </object>
                  ) : (
                    <Text className="text-gray-600 font-semibold p-3 text-center text-sm">
                      No pitch deck uploaded
                    </Text>
                  )}
                </Box>
              )}
            </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PitchDeckModal;
